import { SimpleSelectUrlParamsFilter } from 'entities/filters/simple-select-url-params-filter';

export const COMPANY_DUPLICATES_OPTIONS = [
  { value: 'true', label: 'С дублями' },
  { value: 'false', label: 'Без дублей' }
];

export const CompanyDuplicatesFilter = () => (
  <SimpleSelectUrlParamsFilter
    queryParamName="hasDuplicates"
    label="Дубли компаний"
    defaultValue=""
    items={COMPANY_DUPLICATES_OPTIONS}
  />
);
